import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { IAction, IRewardScore } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";

export class RewardHistoricDataSource extends MatTableDataSourceExtended<IAction> {
  public reward: IRewardScore;

  sortingDataAccessor = (data: IAction, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "date":
        return moment(data.actionDate).unix();
      case "action":
        return data.action.toString();
      case "comment":
        return this.reward?.notes?.[data.commentId]?.text || "";
      default:
        return "";
    }
  };

  constructor(reward: IRewardScore) {
    super();
    this.reward = reward;
  }

  public loadData(reward: IRewardScore): void {
    this.data = reward?.actionsNotesHistory;
  }
}
